<svg ref="svg" 
     class="tt-o-icon"
     :class="classes"
     :aria-hidden="ariaHidden"
     :aria-labelledby="title ? labelId : null"
     :focusable="ariaHidden ? 'false' : 'true'"
     v-on="$listeners">
  <title v-if="title" :id="labelId">{{title}}</title>
  <use v-bind:xlink:href="iconId" />
</svg>